export default __webpack_public_path__ + "img/GPSMNDeC.c79ccfad.svg";